module.exports = __webpack_public_path__ + "img/nxtagro.ef689ad1.png";